export class IconsWrapper {
  constructor(overridesIcons) {
    this._overrideMiamIcon(overridesIcons);
  }

  /**
   * @optional if this function is not implemented or partialy
   * it 'll use default miam icon
   */
   _overrideMiamIcon(overridesIcons) {
    overridesIcons.forEach( tuple => {
      window.mealz.overrideIcon(tuple[0],tuple[1]);
    });
  }
}
